export function arc(ctx) {
    return {
        styles: {
            // background arc track (mix(BORDER, SCR_GRAD, 0.5) = #696e75)
            main:      { ...ctx.pretty, radius: 999, line_color: '#696e75', line_width: 15 },
            indicator: { line_color: ctx.primary, line_width: 15, line_rounded: true },
            knob:      { bg_color: '#ffffff', padding: 0, border_width: 0, border_color: ctx.BORDER },
        },
    };
}
